const { linkDocumentToPatient } = require('api/Documents');
const { showAlert } = require('components/shared/Alert/Alert');

export default async function selectPatient({
  patient,
  patientSelection,
  setShowInstantPacket,
  setPatientSelection,
  navigate,
  queryClient
}) {
  if (patientSelection?.action === 'instant_packet') {
    setShowInstantPacket(true);
    setPatientSelection({ show: false, id: patient?.id });
    return;
  }
  if (patient?.id !== patientSelection?.patient?.id) {
    const linked = await linkDocumentToPatient(navigate, {
      patientId: patient?.id || null,
      id: patientSelection?.id,
      type: patientSelection?.type
    });

    queryClient.setQueriesData(['practice-documents'], (old) => {
      return {
        ...old,
        documents: old?.documents?.map((doc) =>
          doc.id === patientSelection?.id
            ? {
                ...doc,
                patient: {
                  id: patient?.id,
                  f_name: patient?.f_name,
                  l_name: patient?.l_name,
                  dob: patient?.dob
                },
                patient_id: patient?.id || null,
                myportal: patientSelection?.patient?.id !== patient?.id ? false : doc.myportal
              }
            : doc
        )
      };
    });

    if (patientSelection?.patient?.id) {
      queryClient.setQueriesData(['chart-documents', patientSelection?.patient?.id], (old) => {
        return {
          ...old,
          documents: old?.documents?.filter((doc) => doc?.id !== patientSelection?.id)
        };
      });
      queryClient.setQueriesData(['attachment-documents', patientSelection?.appointment], (old) => {
        return {
          ...old,
          documents: old?.documents?.filter((doc) => doc?.id !== patientSelection?.id)
        };
      });
    }

    if (patient?.id) {
      queryClient.setQueriesData(['chart-documents', patient?.id], (old) => {
        return { ...old, documents: [linked.document, ...(old?.documents || [])] };
      });
    }

    if (linked.document) {
      showAlert({
        message: patient?.id
          ? 'Document linked to patient successfully'
          : 'Document unlinked from patient successfully',
        color: 'success'
      });
    } else {
      showAlert({
        message: patient?.id
          ? 'Failed to link document to patient'
          : 'Failed to unlink document from patient',
        color: 'danger'
      });
    }
  }

  setPatientSelection({ show: false, patient: null });
}
